import { render, staticRenderFns } from "./NotifLikeMyPost.vue?vue&type=template&id=468aa8d8&scoped=true"
import script from "./NotifLikeMyPost.vue?vue&type=script&lang=js"
export * from "./NotifLikeMyPost.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=468aa8d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468aa8d8",
  null
  
)

export default component.exports